import { ACCESS_TOKEN, ADMIN, REFRESH_TOKEN } from "./constants";

export function getInitialAuth() {
  const access = localStorage.getItem(ACCESS_TOKEN);
  const refresh = localStorage.getItem(REFRESH_TOKEN);
  const admin = JSON.parse(localStorage.getItem(ADMIN) as string);
  return { isAuthenticated: !!(access && refresh), admin };
}
